import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.ActivationCodeRestService
 *
 * @description
 * This class contains methods used to manage information about activation codes
 * using http requests.
 */
export default class ActivationCodeRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.ActivationCodeRestService#getAllAsync
     * @methodOf rest.services.ActivationCodeRestService
     * @function
     *
     * @description
     * Retrieves activation-codes.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('activation-codes/');

    }

    /**
    * @ngdoc function
    * @name rest.services.ActivationCodeRestService#getById
    * @methodOf rest.services.ActivationCodeRestService
    * @function
    *
    * @description
    * Retrieves activation-code.
    *
    * @returns {Promise} The promise of the call.
    */
    getById(id) {

        return super.getAllAsync(`activation-codes/${id}/`);

    }

    /**
     * @ngdoc function
     * @name rest.services.ActivationCodeRestService#updateAsync
     * @methodOf rest.services.ActivationCodeRestService
     * @function
     *
     * @description
     * Updates an activation code.
     *
     * @param {string} activationCodeId activation code identifier
     * @param {object} activationCodePayload activation code payload
     *
     * @returns {Promise} The promise of the call.
     */
    updateAsync(activationCodeId, activationCodePayload) {

        return super.update(activationCodeId, activationCodePayload, 'activation-codes/');

    }

}

_serviceDependencies.push(ActivationCodeRestService);

angular.module('rest.services')
    .service('ActivationCodeRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/activationCodeRestService.js